import { RootState } from 'types';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './OrderMatchAlert.redux';

const selectDomain = (state: RootState) => state?.orderMatchAlert || initialState;

export const selectOrderMatchAlert = createSelector([selectDomain], data => data);
export const selectUnreadOrderIds = createSelector([selectDomain], data => data.unreadOrderIds);

